import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { ApiService } from '../api.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {Router} from "@angular/router";
import { ObservablesService } from '../observables.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-business',
  templateUrl: './add-business.component.html',
  styleUrls: ['./add-business.component.scss']
})
export class AddBusinessComponent implements OnInit {
  busienesses:any=[];
  editStatus:boolean = false;
  editId:any='';
  closeResult: string;
  businessForm: FormGroup;
  userForm: FormGroup;
  user_id:any;
  bussiness_name:any;
  loggedUserInfo:any=[];
  industries:any=[]
  constructor(private datePipe:DatePipe, private modalService: NgbModal, private observables:ObservablesService, private formBuilder: FormBuilder,private api:ApiService,public router: Router) { }

  ngOnInit() {
    this.createForm()
    this.getIndustries()
    this.getBusinesses()
  }

  getIndustries(){
    this.api.send("findDb",{
      table:"industries"
    }).then((res:any)=>{
      this.industries = res.data;

    })
  }


  createForm(){
    this.businessForm = this.formBuilder.group({
      industry_id:['', Validators.required],
      name:['', Validators.required],
      gstin:'',
      h_level:[null, Validators.required],
      mobile:['', Validators.required],
      address:[''],
      city:[''],
      state:['', Validators.required],
      pincode:[null],
      slip_subscribe_status:[false, Validators.required],
      invoice_subscribe_status:[true, Validators.required],
      tag_subscribe_status:[false, Validators.required]
    });
  }



  getBusinesses(){

     this.api.send("findDb",{
       table:"businesses",
       order:"id DESC"
     }).then((result:any)=>{
     this.busienesses=result.data
     // return Responses;
   })
  }

  setView(event,view){
    if(event.checked){

    }else{
      if(view == 'slip'){
        this.businessForm.patchValue({invoice_subscribe_status:true})
      }else{
        this.businessForm.patchValue({slip_subscribe_status:true})
      }
    }
  }

  submitData(value,formDirective:FormGroupDirective){

    this.api.send("insertDb",{
      table:"businesses",
      data:value
    }).then((result:any)=>{
      if(result.data.affectedRows){
        this.addRole(result.data.insertId,value.h_level).then((res:any)=>{
          if(res){

            this.setPreferences(result.data.insertId).then((pRes:any)=>{

              formDirective.resetForm();
              this.businessForm.reset()
              this.businessForm.patchValue({slip_subscribe_status:true,invoice_subscribe_status:true,tag_subscribe_status:false})
              this.getBusinesses();
              this.observables.showToastMessage({type:0, message:"Business Added Successfully"})
            })

          }else{
            this.observables.showToastMessage({type:1, message:"Business Added but, Some problem while adding Role, add Manually or try again."})
          }
        })
      }else{

        this.observables.showToastMessage({type:1, message:"Some problem while adding Business details, try again."})
      }
    })
  }

  setPreferences(business_id){
    return new Promise((resolve)=>{

      this.api.send("insertDb",{
        table:"preferences",
        data:{
          business_id:business_id,
          invoice_title:'INVOICE',
          slip_title:'DELIVERY CHALLAN',
          item_name:"Particulars",
          unit_variable_1:"Column1",
          unit_variable_1_status:1,
          unit_variable_2:"Column2",
          unit_variable_2_status:1,
          unit_variable_3:"Column3",
          unit_variable_3_status:1,
          unit:"Quantity",
          unit_status:1,
          tax:"GST",
          tax_status:1,
          unit_price:"Rate",
          unit_price_status:1,
        }
      }).then((res:any)=>{

        if(res.data.affectedRows){
          this.observables.showToastMessage({type:0, message:"Preferences Saved"})
          resolve(true)
        }else{
          resolve(true)
          this.observables.showToastMessage({type:1, message:"Preferences Not Saved"})

        }
      })
    })
  }

  addRole(business_id,level){
    return new Promise((resolve)=>{

      this.api.send("insertDb",{
        table:"roles",
        data:{
          business_id:business_id,
          role:'ADMIN',
          level:1,
          is_last_level:(level == 1)?1:0,
          item_view_status:1,
          item_create_status:1,
          item_edit_status:1,
          item_delete_status:1,
          party_view_status:1,
          party_create_status:1,
          party_edit_status:1,
          party_delete_status:1,
          slip_view_status:1,
          slip_create_status:1,
          slip_edit_status:1,
          slip_delete_status:1,
          invoice_view_status:1,
          invoice_create_status:1,
          invoice_edit_status:1,
          invoice_delete_status:1,
          user_view_status:1,
          user_create_status:1,
          user_edit_status:1,
          user_delete_status:1,
          role_view_status:1,
          role_create_status:1,
          role_edit_status:1,
          role_delete_status:1
        }
      }).then((result:any)=>{
        if(result.data.affectedRows){
          resolve(true)
        }else{
          resolve(false)
        }
      })
    })
  }

  updateRole(level,business_id){
    return new Promise((resolve)=>{

      this.api.send("updateDb",{
        table:"roles",
        data:{
          is_last_level:(level == 1)?1:0
        },
        conditions:[{role:"ADMIN",business_id:business_id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){
          resolve(true)
        }else{
          resolve(false)
        }
      })
    })
  }

  setActivationDate(event,business){
    // console.log('event=',event)
    // console.log('business=',business)
    if(business.trail_status != 1 && event.checked){
      this.api.send("updateDb",{
        table:'businesses',
        data:{
          activate_date:this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
          activation_date:this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
          trail_status:1
        },
        conditions:[{id:business.id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0, message:"Business Activation date updated"})
          this.getBusinesses()
        }else{
          this.observables.showToastMessage({type:1, message:"Some problem for updating Activation date, Try again"})

        }
      })
    }
  }
  changeActiveStatus(event,business){
    // console.log('event=',event)
    // console.log('business=',business)
    if(event.checked){
      this.api.send("updateDb",{
        table:'businesses',
        data:{
          reactivate_date:this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
          active_status:1
        },
        conditions:[{id:business.id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0, message:"Business Activated"})
          this.getBusinesses()
        }else{
          this.observables.showToastMessage({type:1, message:"Some problem for Business Activation, Try again"})

        }
      })
    }else{
      this.api.send("updateDb",{
        table:'businesses',
        data:{
          deactivate_date:this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
          active_status:0
        },
        conditions:[{id:business.id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0, message:"Business Deactivated"})
          this.getBusinesses()
        }else{
          this.observables.showToastMessage({type:1, message:"Some problem for Business Deactivation, Try again"})

        }
      })
    }
  }

  cancel(formDirective:FormGroupDirective){
    formDirective.resetForm();
    this.businessForm.reset()
    this.businessForm.patchValue({slip_subscribe_status:true,invoice_subscribe_status:true,tag_subscribe_status:false})
    this.editStatus = false;
    this.editId = ''
  }
  updateData(value,formDirective:FormGroupDirective){
    // console.log("values==",value)
    if(value.slip_subscribe_status){
      value.slip_subscribe_status = 1;
    }else{
      value.slip_subscribe_status = 0;
    }
    if(value.invoice_subscribe_status){
      value.invoice_subscribe_status = 1;
    }else{
      value.invoice_subscribe_status = 0;
    }

    this.api.send("updateDb",{
      table:"businesses",
      data:value,
      conditions:[{id:this.editId}]
    }).then((result:any)=>{
      if(result.data.affectedRows){
        this.updateRole(value.h_level,this.editId).then((res:any)=>{
          formDirective.resetForm();
          this.businessForm.reset()
          this.businessForm.patchValue({slip_subscribe_status:true,invoice_subscribe_status:true,tag_subscribe_status:false})
          this.getBusinesses();
          this.editStatus = false;
          this.editId = ''
          this.observables.showToastMessage({type:0, message:"Business Updated Successfully"})
        })

      }else{
        this.observables.showToastMessage({type:1, message:"Some problem while updating business details, try again."})
      }
    })
  }


  deleteBusiness(id){
    if(confirm("Are you sure want to delete Business?")){

      this.api.send("deleteDb",{
        table:"businesses",
        conditions:[{id:id}]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          this.observables.showToastMessage({type:0, message:"Busieness Deleted Successfully"})
          this.getBusinesses();
        }

      })
    }
  }

  editBusiness(business){
    this.businessForm.patchValue({
      industry_id:business.industry_id,
      name:business.name,
      gstin:business.gstin,
      h_level:business.h_level,
      mobile:business.mobile,
      address:business.address,
      city:business.city,
      state:business.state,
      pincode:business.pincode,
      slip_subscribe_status:business.slip_subscribe_status,
      invoice_subscribe_status:business.invoice_subscribe_status,
      tag_subscribe_status:business.tag_subscribe_status
    });

    this.editStatus = true;
    this.editId = business.id;
  }


  addUser(business_id,business_name){
    this.router.navigate(['/add-business-user'],{ state: { business_id: business_id,business_name:business_name} })
    // this.api.send('findDb',{
    //   table:'roles',
    //   conditions:[{business_id:business_id}]
    // }).then((res:any)=>{
    //   if(res.data.length > 0){
    //     this.userForm.patchValue({role_id:res.data[0].id})
    //   }
    // })
    // this.bussiness_name = business_name;
    // this.userForm= this.formBuilder.group({
    //   business_id:[business_id,Validators.required],
    //   username:[null,Validators.required],
    //   password:[null,Validators.required],
    //   full_name:[null,Validators.required],
    //   role_id:[null,Validators.required]
    // });
    // this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }

  // private getDismissReason(reason: any): string {
  //
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return  `with: ${reason}`;
  //   }
  // }


  // save(value){
  //   this.api.send("insertDb",{
  //     table:'users',
  //     data:value
  //   }).then((res:any)=>{
  //     if(res.data.affectedRows){
  //       this.userForm.reset()
  //       this.observables.showToastMessage({type:0,message:'User saved..'});
  //     }else{
  //      this.observables.showToastMessage({type:1,message:'User not saved..'});
  //     }
  //   })
  // }


}
